import { render, staticRenderFns } from "./MainMenuItem.vue?vue&type=template&id=66f20228&"
import script from "./MainMenuItem.vue?vue&type=script&lang=js&"
export * from "./MainMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports